// extracted by mini-css-extract-plugin
module.exports = {"root":"ValueEditDialog_root__xG_1n","actions":"ValueEditDialog_actions__1WQDo"};